import React from "react";
import "./SteamCard.css";

const STEAM_ASSETS = "https://shared.akamai.steamstatic.com/store_item_assets/steam/apps";

export const steamStoreUrl = (appId: string) => `https://store.steampowered.com/app/${appId}/`;
// Newer Steam apps store the header image under a hashed folder, so it can be overridden
export const steamHeaderUrl = (appId: string, header?: string) => `${STEAM_ASSETS}/${appId}/${header ?? "header.jpg"}`;

interface SteamCardProps {
    appId: string;
    title?: string;
    header?: string;
    storeLabel?: string;
    buttonLabel?: string;
}

export default function SteamCard({
    appId,
    title,
    header,
    storeLabel = "в Steam",
    buttonLabel = "Открыть в Steam",
}: SteamCardProps) {
    return (
        <a className="SteamCard" href={steamStoreUrl(appId)} target="_blank" rel="noreferrer">
            <img src={steamHeaderUrl(appId, header)} alt={title} loading="lazy"/>
            <div className="SteamCard-body">
                <span className="SteamCard-title">{title}</span>
                <span className="SteamCard-store">{storeLabel}</span>
                <span className="SteamCard-btn">{buttonLabel}</span>
            </div>
        </a>
    );
}
